import { Reveal } from "./Reveal";
import { ICONS } from "@/lib/icons";
import copy from "@/content/homepage-copy.json";

const { arrowRight: ArrowRight } = ICONS;

export const FinalCta = () => {
  const c = copy.finalCta;
  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-[88px]" data-testid="final-cta-section">
      <Reveal>
        <div className="radial-fade relative overflow-hidden rounded-panel border border-brand-line bg-brand-surface px-6 py-16 text-center sm:px-12 md:py-24">
          <h2 className="mx-auto max-w-2xl font-display text-[30px] font-semibold leading-[1.12] tracking-[-0.025em] md:text-[40px]">
            {c.title}
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-[18px] leading-[1.55] text-brand-sec">{c.text}</p>
          <a
            href="/rejestracja"
            data-testid="final-cta-button"
            className="mt-9 inline-flex items-center justify-center gap-2 rounded-button bg-brand-accent px-8 py-4 text-base font-semibold text-brand-on transition-transform duration-200 hover:-translate-y-0.5"
          >
            {c.button}
            <ArrowRight size={18} strokeWidth={2} aria-hidden="true" />
          </a>
        </div>
      </Reveal>
    </section>
  );
};
